<template>
    <span>
      <input
          type="hidden"
          name="files"
          :id="inputId"
          :data-multiple="multiple"
          :data-crop="crop"
          :data-clearable="clearable"
          :data-images-only="imagesOnly"
          :data-do-not-store="doNotStore"
          @input="$emit('input', $event.target.value)"
      />
    </span>
</template>

<script>
    import uploadcare from 'uploadcare-widget'
    import UploadCareMixin from './../mixins/uploadCare'

    export default {
        mixins: [UploadCareMixin],

        data() {
            return {
                widget: null,
            };
        },

        computed: {
            inputId () {
                return 'upload-care-input-' + _.random(0, 1000);
            }
        },

        mounted() {
          try{
            if (this.multiple) {
              this.widget = uploadcare.MultipleWidget('#'+this.inputId);
            } else {
              this.widget = uploadcare.SingleWidget('#'+this.inputId);
            }

            this.widget.onChange((file) => {
              this.onFileDone(file);
            });

            this.currentValue = this.value;
            this.onValueChange(this.value);
          }catch (e) {
            console.log(e)
          }
        },

        methods: {
            onValueChange(val) {
                if (val != null && val != '') {
                    this.currentValue = val;
                    this.widget.value(this.getValueToUploadCare())
                } else {
                    this.currentValue = null;
                    this.widget.value(null);
                }
            },

            clear() {
                this.$emit('input', [])
                this.widget.value(null)
            }
        }
    };
</script>
